import { useUiStore } from '@/store'

// 全局 toast: 任何组件调用 showPrompt(msg) 都会触发 App 层挂载的 UiPrompt
// 用法:
//   const { showPrompt } = usePrompt()
//   showPrompt('操作成功')          // 默认 1500ms
//   showPrompt('稍后重试', 800)     // 自定义时长
export function usePrompt() {
  const uiStore = useUiStore()
  return {
    showPrompt: (message, duration) => uiStore.showPrompt(message, duration)
  }
}
